export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13745.e6b93ada.jpg";